export default "__VITE_ASSET__CVxVfPxC__"